export const filterObjectByKeys = <T>(
  keys: Array<keyof T>,
  obj: T,
): Partial<T> => {
  return keys.reduce((result: Partial<T>, key) => {
    if (key in obj) {
      result[key] = obj[key];
    }
    return result;
  }, {});
};
